import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const user = {
    state: () => ({
        id: 0,
        nickname: '',
        headimgurl: '',
        store_name: '',
        store_id: '',
        tel: '',
        default_addr: {}
    }),
    mutations: {
        SETUSERINFO: (state, info) => {
            sessionStorage.setItem('nickname', info.nickname ? info.nickname : '')
            sessionStorage.setItem('tel', info.tel ? info.tel : '')
            sessionStorage.setItem('headimgurl', info.headimgurl ? info.headimgurl : '')
            sessionStorage.setItem('id', info.id ? info.id : '')
            sessionStorage.setItem('inviter_id', info.inviter_id ? info.inviter_id : '')
            sessionStorage.setItem('alipay_account', info.alipay_account ? info.alipay_account : '')
            // sessionStorage.setItem('store_name', info.store_name)
            state.id = info.id
            state.nickname = info.nickname
            state.headimgurl = info.headimgurl
            // state.store_name = info.store_name
            state.store_id = info.store_id
            state.inviter_id = info.inviter_id
            state.tel = info.tel
        },
        DEFAULTADDR: (state, info) => {
            sessionStorage.setItem('default_addr', JSON.stringify(info))
            state.default_addr = info
        }
    },
    actions: {
        getUserInfo ({ commit }) {
            return new Promise((resolve, reject) => {
                Vue.http.get('/api/user/info').then(response => {
                    if (response.code === 0) {
                        commit('SETUSERINFO', response.data)
                        resolve(response.data)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getDefaultAddress ({ commit }) {
            return new Promise((resolve, reject) => {
                Vue.http.get('/api/user/defaultAddress').then(response => {
                    if (response.code === 0) {
                        commit('DEFAULTADDR', response.data)
                        resolve(response.data)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}

const store = new Vuex.Store({
    modules: {
        user
    }
}) // 这里你可能已经有其他 module

store.registerModule('vux', { // 名字自己定义
    state: {
        isLoading: false,
        suspensionbox: undefined
    },
    mutations: {
        updateLoadingStatus (state, payload) {
            state.isLoading = payload.isLoading
        },
        updateSuspensionbox (state, payload) {
            state.suspensionbox = payload.count
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js